import React from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { Box, Typography, InputAdornment } from '@mui/material'

import { HHFormNumberField } from 'components/form-fields/v5'
import { WEIGHT_DECIMAL_SCALE } from 'components/pricing/DisposalFeesV2/create-edit-disposal-fee-dialog/settings'
import { FIELD_WIDTH } from 'components/work-order/disposal-ticket-dialog/disposal-fee/fields/settings'

const IncludedField = ({ index, unit = '' }) => {
  const { control } = useFormContext()

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography>{`Included ${unit}s:`}</Typography>
      <HHFormNumberField
        sx={{ width: FIELD_WIDTH }}
        control={control}
        name={`materials.${index}.includedTonnage`}
        placeholder=""
        decimalScale={WEIGHT_DECIMAL_SCALE}
        InputProps={{ endAdornment: <InputAdornment position="end">{`${unit}s`}</InputAdornment> }}
      />
    </Box>
  )
}

IncludedField.propTypes = {
  index: PropTypes.number,
  unit: PropTypes.string,
}

export default IncludedField
